import "./honeybadger";

import { useCable } from "./turbo/cable_stream_source_element";
import { cable } from "@hotwired/turbo-rails";
useCable(cable);
import "./turbo/frame_missing";
import "./turbo/instant_page_scroll";

import "./controllers";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import "./cookie_consent";
import { install as installAnalyticsUserId } from "./analytics/user_id";
installAnalyticsUserId();
